<script>
import { getOnShelfProducts, getEnabledCategories } from '../../api/product';
import { leftLikeDict } from '../../api/system';
import Constant from '../../utils/Constant';

export default {
  data() {
    return {
      productBanner: {},
      productList: [],
      page: 0,
      pageSize: 12,
      loading: false,
      noMore: false,
      selectedCategoryId: null, // 选中的分类ID
      searchName: '', // 搜索关键词
      categoryOptions: [
        { label: '全部产品', value: null }
      ]
    }
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.PRODUCT_BANNER);
      if (res.data && res.data.data) {
        const bannerData = res.data.data;
        // 解析字典数据
        this.productBanner = {
          title: '',
          subtitle: '',
          image: ''
        };
        
        bannerData.forEach(item => {
          if (item.dictKey === Constant.PRODUCT_BANNER_TITLE) {
            this.productBanner.title = item.dictValue;
          } else if (item.dictKey === Constant.PRODUCT_BANNER_SUB_TITLE) {
            this.productBanner.subtitle = item.dictValue;
          } else if (item.dictKey === Constant.PRODUCT_BANNER_IMAGE) {
            this.productBanner.image = item.dictValue;
          }
        });
      }
    },

    // 加载分类列表
    async loadCategories() {
      try {
        const res = await getEnabledCategories();
        if (res.data && res.data.data) {
          const categories = res.data.data.map(cat => ({
            label: cat.categoryName,
            value: cat.id
          }));
          this.categoryOptions = [
            { label: '全部产品', value: null },
            ...categories
          ];
        }
      } catch (error) {
        console.error('加载分类失败', error);
      }
    },

    async getProductsFunc() {
      if (this.loading || this.noMore) return;

      this.loading = true;

      try {
        const params = {
          page: this.page,
          size: this.pageSize
        };
        
        if (this.selectedCategoryId) {
          params.categoryId = this.selectedCategoryId;
        }
        
        if (this.searchName && this.searchName.trim()) {
          params.name = this.searchName.trim();
        }

        const res = await getOnShelfProducts(params);

        if (res.data && res.data.data && res.data.data.content) {
          const newData = res.data.data.content;

          if (newData.length < this.pageSize) {
            this.noMore = true;
          }

          if (this.page === 0) {
            this.productList = newData;
          } else {
            this.productList = [...this.productList, ...newData];
          }

          if (newData.length > 0) {
            this.page++;
          }
        } else {
          this.noMore = true;
        }
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false;
      }
    },

    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.getProductsFunc();
      }
    },

    // 切换分类
    changeCategory(categoryId) {
      this.selectedCategoryId = categoryId;
      this.page = 0;
      this.noMore = false;
      this.productList = [];
      this.getProductsFunc();
    },

    // 搜索
    handleSearch() {
      this.page = 0;
      this.noMore = false;
      this.productList = [];
      this.getProductsFunc();
    },

    // 清空搜索
    clearSearch() {
      this.searchName = '';
      this.handleSearch();
    },

    // 查看产品详情
    openProductDetail(id) {
      if (this.$router && this.$router.resolve) {
        const routeData = this.$router.resolve({ path: '/product_detail/' + id });
        window.open(routeData.href, '_blank');
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
    this.loadCategories()
    this.getProductsFunc()
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<template>
  <div class="product_wrap">
    <!-- 顶部Banner -->
    <div class="product_banner" :style="{ background: `url(${productBanner.image}) center center no-repeat`, backgroundSize: 'cover' }">
      <div class="banner_content" v-if="productBanner.title || productBanner.subtitle">
        <div class="banner_title" v-if="productBanner.title">{{ productBanner.title }}</div>
        <div class="banner_desc" v-if="productBanner.subtitle">{{ productBanner.subtitle }}</div>
      </div>
    </div>

    <div class="container">
      <!-- 搜索栏 -->
      <div class="search_bar">
        <el-input
          v-model="searchName"
          placeholder="搜索产品名称"
          class="search_input"
          clearable
          @keyup.enter="handleSearch"
          @clear="clearSearch"
        >
          <template #append>
            <el-button @click="handleSearch">搜索</el-button>
          </template>
        </el-input>
      </div>

      <!-- 分类导航 -->
      <div class="category_nav">
        <div
          v-for="item in categoryOptions"
          :key="item.value"
          :class="['category_item', { active: selectedCategoryId === item.value }]"
          @click="changeCategory(item.value)"
        >
          {{ item.label }}
        </div>
      </div>

      <h2 class="section-title">产品展示</h2>

      <!-- 产品网格 -->
      <div class="product-grid">
        <article class="product-card" v-for="item in productList" :key="item.id" @click="openProductDetail(item.id)">
          <div class="card-image-wrapper">
            <img :src="item.image" :alt="item.name" class="card-image" />
            <div class="card-category-tag">{{ item.category?.categoryName || '未分类' }}</div>
          </div>
          <div class="card-content">
            <h3 class="card-title">{{ item.name }}</h3>
            <p class="card-desc">{{ item.description }}</p>
            <div class="card-efficacy" v-if="item.efficacy">
              <span class="efficacy-label">功效：</span>
              <span>{{ item.efficacy }}</span>
            </div>
            <div class="card-footer">
              <div class="card-price">
                <span class="price-symbol">¥</span>
                <span class="price-value">{{ item.price }}</span>
              </div>
              <div class="card-meta">
                <span class="sales">销量: {{ item.salesVolume || 0 }}</span>
              </div>
            </div>
          </div>
        </article>
      </div>

      <!-- 加载状态 -->
      <div class="footer-status">
        <div v-if="loading" class="loading-box">
          <span class="loading-icon"></span> 努力加载中...
        </div>
        <div v-if="noMore && productList.length > 0" class="no-more-line">
          <span>已显示全部产品</span>
        </div>
        <div v-if="noMore && productList.length === 0" class="empty-box">
          暂无产品
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product_wrap {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}

.product_banner {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }
}

.banner_content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
}

.banner_title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner_desc {
  font-size: 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.search_bar {
  max-width: 600px;
  margin: 0 auto 30px;
}

.search_input {
  width: 100%;
}

.category_nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.category_item {
  padding: 10px 30px;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    border-color: #409eff;
    color: #409eff;
    transform: translateY(-2px);
  }

  &.active {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background: #409eff;
    margin: 15px auto 0;
    border-radius: 2px;
  }
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.product-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
}

.card-image-wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;

  .product-card:hover & {
    transform: scale(1.1);
  }
}

.card-category-tag {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(64, 158, 255, 0.9);
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 44px;
}

.card-efficacy {
  font-size: 13px;
  color: #888;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.efficacy-label {
  color: #409eff;
  font-weight: 500;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.card-price {
  color: #f56c6c;
  font-weight: bold;
}

.price-symbol {
  font-size: 16px;
}

.price-value {
  font-size: 24px;
}

.card-meta {
  font-size: 13px;
  color: #999;
}

.footer-status {
  text-align: center;
  padding: 30px 0;
}

.loading-box {
  color: #409eff;
  font-size: 14px;
}

.loading-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #409eff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-more-line {
  color: #999;
  font-size: 14px;
  
  span {
    position: relative;
    padding: 0 20px;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 60px;
      height: 1px;
      background: #ddd;
    }
    
    &::before {
      right: 100%;
    }
    
    &::after {
      left: 100%;
    }
  }
}

.empty-box {
  color: #999;
  font-size: 16px;
  padding: 60px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product_banner {
    height: 250px;
  }

  .banner_title {
    font-size: 32px;
  }

  .banner_desc {
    font-size: 16px;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 15px;
  }

  .card-image-wrapper {
    height: 180px;
  }

  .card-content {
    padding: 15px;
  }

  .card-title {
    font-size: 16px;
  }

  .price-value {
    font-size: 20px;
  }
}
</style>
